import { Col, Row } from 'react-bootstrap';
import MediaQuery from 'react-responsive';
import transpport from '../../../asset/Home/transpport.png';

import './style.css';

const AboutRegular = () => (
  <div className="about-regular">
    <Row className="text-title">
      <span>定期便について</span>
    </Row>
    <Row className="text-body">
      定期便をご注文いただくと
      <br />
      その商品の決済が
      <MediaQuery query="(max-width: 414px)">
        <br />
      </MediaQuery>
      毎月自動で行われます。
      <br />
      決済日は毎月25日となります。
      <br />
      定期便のスキップも可能です。
    </Row>
    <Row className="content">
      <Col xs={12} md={4} className="right d-flex align-items-center">
        <span className="btn-span">定期便スキップとは？</span>
      </Col>
      <Col xs={12} md={8} className="left">
        事前にご依頼いただくことで翌月の購入を無しにすることができます。
        <br />
        スキップ月の費用はかかりません。
        <br />
        スキップ月の翌月からは通常通り配送されます。
      </Col>
      <img src={transpport} alt="transpport" style={{ width: '80%' }} />
    </Row>
  </div>
);

export default AboutRegular;
